import { render, staticRenderFns } from "./SanVatList.vue?vue&type=template&id=669ab1ad"
import script from "./SanVatList.vue?vue&type=script&lang=js"
export * from "./SanVatList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports